<template lang="pug">
.d-flex.flex-column.full-width.full-height
  .full-width.full-height.d-flex.align-center(
    :class=`{
      'gap-20 justify-space-between': $vuetify.breakpoint.lgAndUp,
      'gap-10 justify-start': $vuetify.breakpoint.mdAndDown,
    }`
  )
    logo-heading

    .d-flex.gap-24(
      v-if="$vuetify.breakpoint.lgAndUp"
    )
      router-link.no-before.redesignBlack--text.body-1.weight-500.text-nowrap(
        v-for="(route, idx) in activeRoutes"
        :key="idx"
        :to="route.to"
        exact-active-class="redesignPrimaryDarken--text"
      ) {{ route.name }}
    expand-menu(
      v-else
      :type="MENU_TYPES.INDEPEND"
      offset-y
      :close-on-click="true"
      additional-menu-classes="rounded-12 redesign-box-shadow"
    )
      template(#activator="{ on }")
        v-btn.pa-0(
          color="transparent"
          text
          small
          min-width="20px"
          opacity="1"
          v-on="on"
        )
          v-icon(color="redesignBlack") mdi-menu
      v-list
        v-list-item.redesignMainBlack--text.body-1(
          v-for="(route, idx) in activeRoutes"
          :key="idx"
        )
          router-link.no-before.redesignBlack--text.body-1.weight-500.text-nowrap(
            :to="route.to"
            exact-active-class="redesignPrimaryDarken--text"
          ) {{ route.name }}

    .d-flex(
      :class=`{
        'gap-20 ml-12': $vuetify.breakpoint.lgAndUp,
        'gap-10 ml-auto': $vuetify.breakpoint.mdAndDown,
      }`
    )
      v-btn.pa-0(
        v-if="$vuetify.breakpoint.mdAndUp && $user.isMember"
        color="transparent"
        text
        small
        min-width="25px"
        opacity="1"
        @click="$emit('switchSearch')"
      )
        v-icon(
          size="20"
          :color="showSearch ? 'redesignPrimaryDarken' : 'redesignBlack'"
        ) $izoom

      v-btn.pa-0(
        v-if="isAuthenticated && $user.isMember"
        color="transparent"
        text
        small
        min-width="25px"
        opacity="1"
        to="/redesign/my-notifications"
      )
        v-icon(
          :color="isNotificationsPage ? 'redesignPrimaryDarken' : 'redesignBlack'"
          size="21"
        ) {{ notificationsCount ? '$ibell-outline-active' : '$ibell-outline' }}
</template>

<script>
import LogoHeading from './LogoHeading.vue';
import ExpandMenu, { MENU_TYPES } from '../../ExpandMenu.vue';
import TextLoader from '../TextLoader.vue';
import AppButton from '../../controls/AppButton.vue';
import AppTextInput from '../../inputs/AppTextInput.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'NavigationPanel',

  components: {
    LogoHeading,
    ExpandMenu,
    TextLoader,
    AppButton,
    AppTextInput,
  },

  props: {
    showSearch: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      MENU_TYPES,
    };
  },

  computed: {
    ...mapGetters({
      notificationsCount: 'notification/total',
    }),
    isNotificationsPage() {
      return this.$route.name === 'my-notifications';
    },
    isAuthenticated() {
      const { isAuthenticated } = this.$user;
      return isAuthenticated;
    },
    routes() {
      const { isMember, isExpert } = this.$user;
      return [
        {
          name: 'Главная',
          to: '/',
          hidden: isExpert,
        },
        {
          name: 'Мои мероприятия',
          to: '/redesign/home',
          hidden: !this.isAuthenticated || !isMember,
        },
        {
          name: 'Поиск',
          to: '/events-search',
          hidden: !this.isAuthenticated || !isMember,
        },
        {
          name: 'Результаты',
          to: '/redesign/my-history',
          hidden: !this.isAuthenticated || !isMember,
        },
      ];
    },
    activeRoutes() {
      return this.routes.filter((route) => !route.hidden);
    },
  },
};
</script>

<style lang="scss" scoped>
.search_field {
  margin: 0px !important;
  width: 100%;
}
</style>
